import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Profesional",
  icon: "💼",
  templates: [
    {
      title: "Skrip YouTube / Video",
      content: `Tulis skrip untuk video YouTube yang dinarasikan oleh satu orang.
- Topik video adalah [5 kesalahan umum saat bekerja dari rumah — dan cara memperbaikinya].
- Target audiens: [profesional muda yang memulai pekerjaan remote pertama mereka].
- Nada: [ramah, percakapan, dan praktis — seperti saran dari rekan kerja tepercaya].
- Strukturkan dengan hook kuat di dua kalimat pertama, transisi jelas antar poin, dan penutup singkat dengan ajakan bertindak.
- Tulis untuk penyampaian lisan: gunakan paragraf pendek dan pertanyaan retoris untuk menjaga perhatian pendengar.`
    },
    {
      title: "Penjelasan Produk",
      content: `Tulis skrip voiceover untuk video penjelasan produk.
- Produk adalah [aplikasi mobile yang membantu pemilik usaha kecil melacak pengeluaran dengan memindai struk].
- Target audiens: [freelancer dan pemilik usaha kecil yang benci pembukuan].
- Manfaat utama yang harus ditonjolkan:
  1. [Pindai struk dalam 2 detik — tanpa input manual].
  2. [Kategori pengeluaran otomatis dengan saran cerdas].
  3. [Ekspor satu ketuk untuk musim pajak].
- Nada: [jelas, ceria, dan meyakinkan — ini membuat tugas menyakitkan menjadi mudah].
- Jaga kalimat tetap ringkas dan bertenaga. Hindari jargon.`
    },
    {
      title: "Pidato Presentasi",
      content: `Tulis pidato untuk presentasi profesional atau keynote.
- Acara adalah [rapat umum perusahaan untuk memulai kuartal baru].
- Pembicara adalah [seorang pemimpin tim yang berbicara kepada audiens campuran insinyur, desainer, dan manajer].
- Pesan inti: [merayakan kemenangan kuartal lalu, mengakui tantangan dengan jujur, dan menyatukan tim di sekitar fokus yang jelas untuk bulan-bulan mendatang].
- Nada: [percaya diri, tulus, dan memotivasi — bukan bahasa korporat kosong].
- Durasi bicara perkiraan: [4 menit].
- Gunakan frasa percakapan, jeda strategis, dan kalimat penutup yang berkesan.`
    }
  ]
};
